import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {SessionStorageAdsRepository} from '../Repositories/SessionStorageAdsRepository.js'

export class SaveComparatorAdsService extends Service {
  #repository

  #handleError(error) {
    return Promise.reject(
      DomainSharedError.isDomainError({error}) ? error : DomainSharedError.createGenericError({cause: error})
    )
  }

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create() {
    return new SaveComparatorAdsService({repository: SessionStorageAdsRepository.create()})
  }

  @AsyncInlineError()
  async execute({ads}) {
    try {
      const [error, response] = await this.#repository.saveComparatorAds({ads})
      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}
